/**
 * Function selection (leaves-373f)
 * No main title — top-right note + comparison image below.
 * Vertical spacing matches Featured: LED Strip.
 * ImageComparison drag (replaces PageFly runtime).
 * Placement is owned by leaves-canyon-feature.js (leavesPlaceHomeSections).
 */
(function () {
  'use strict';

  if (!document.documentElement || document.documentElement.dataset.leavesFnJoby === '1') return;
  document.documentElement.dataset.leavesFnJoby = '1';

  function textOf(node) {
    return ((node && node.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }

  function placeSection(section) {
    if (typeof window.leavesPlaceHomeSections === 'function') {
      window.leavesPlaceHomeSections();
      return;
    }
    var video = document.querySelector('#leaves-home [data-section-id="leaves-26b5"]');
    if (!video || !section || !video.parentNode) return;
    if (section.nextElementSibling === video) return;
    video.parentNode.insertBefore(section, video);
  }

  /** FOUC + lazy + move can leave imgs at naturalWidth 0; force eager decode. */
  function wakeImages(compare) {
    if (!compare) return;
    var imgs = compare.querySelectorAll('img');
    Array.prototype.forEach.call(imgs, function (img) {
      img.loading = 'eager';
      img.removeAttribute('fetchpriority');
      if (img.complete && img.naturalWidth) return;
      var src = img.currentSrc || img.getAttribute('src') || '';
      if (!src) return;
      // Retrigger load without losing srcset
      img.addEventListener(
        'load',
        function () {
          if (typeof window.leavesPlaceHomeSections === 'function') window.leavesPlaceHomeSections();
        },
        { once: true }
      );
      try {
        img.decode().catch(function () {});
      } catch (e) {}
      if (!img.complete || !img.naturalWidth) {
        img.src = src;
      }
    });
  }

  function wireSlider(compare) {
    if (!compare || compare.dataset.leavesBaWired === '1') return;
    compare.dataset.leavesBaWired = '1';

    var content = compare.querySelector('.leaves-ba-content') || compare;
    var before = compare.querySelector('.leaves-ba-before');
    var handle = compare.querySelector('.leaves-ba-handle');
    if (!before || !handle) return;

    var vertical = compare.getAttribute('data-leaves-ba-direction') === 'vertical';
    var dragging = false;

    function setPos(pct) {
      pct = clamp(pct, 0, 100);
      if (vertical) {
        before.style.height = pct + '%';
        before.style.width = '';
        handle.style.top = pct + '%';
        handle.style.left = '';
      } else {
        before.style.width = pct + '%';
        before.style.height = '';
        handle.style.left = pct + '%';
        handle.style.top = '';
      }
      handle.setAttribute('aria-valuenow', String(Math.round(pct)));
    }

    function pctFromClient(clientX, clientY) {
      var rect = content.getBoundingClientRect();
      if (!rect.width || !rect.height) return 50;
      if (vertical) return ((clientY - rect.top) / rect.height) * 100;
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function clientFromEvent(e) {
      if (e.touches && e.touches[0]) {
        return { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
      if (e.changedTouches && e.changedTouches[0]) {
        return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
      }
      return { x: e.clientX, y: e.clientY };
    }

    function onPointerDown(e) {
      if (e.button != null && e.button !== 0) return;
      dragging = true;
      compare.classList.add('is-dragging');
      var pt = clientFromEvent(e);
      setPos(pctFromClient(pt.x, pt.y));
      if (e.cancelable) e.preventDefault();
    }

    function onPointerMove(e) {
      if (!dragging) return;
      var pt = clientFromEvent(e);
      setPos(pctFromClient(pt.x, pt.y));
      if (e.cancelable) e.preventDefault();
    }

    function onPointerUp() {
      if (!dragging) return;
      dragging = false;
      compare.classList.remove('is-dragging');
    }

    compare.addEventListener('mousedown', onPointerDown);
    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('mouseup', onPointerUp);

    compare.addEventListener('touchstart', onPointerDown, { passive: false });
    window.addEventListener('touchmove', onPointerMove, { passive: false });
    window.addEventListener('touchend', onPointerUp);
    window.addEventListener('touchcancel', onPointerUp);

    handle.addEventListener('keydown', function (e) {
      var now = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
      var step = e.shiftKey ? 10 : 2;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        setPos(now - step);
        e.preventDefault();
      } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        setPos(now + step);
        e.preventDefault();
      } else if (e.key === 'Home') {
        setPos(0);
        e.preventDefault();
      } else if (e.key === 'End') {
        setPos(100);
        e.preventDefault();
      }
    });

    var initial = parseFloat(handle.getAttribute('aria-valuenow'));
    if (!isFinite(initial)) {
      initial = parseFloat(String(before.style.width || before.style.height || '').replace('%', '')) || 50;
    }
    setPos(initial);
  }

  function build(section) {
    var existing = section.querySelector('.leaves-fn-joby');
    if (existing && existing.getAttribute('data-layout') === 'note-tr-v3') {
      placeSection(section);
      return true;
    }
    if (existing) existing.remove();

    var compare = section.querySelector('[data-leaves-type="ImageComparison"]');
    if (!compare) return false;

    var noteText =
      'Some products come in two versions: Basic model and Vibrant Color model. Soft everyday glow, or richer color when you want evenings to stand out.';

    var root = document.createElement('div');
    root.className = 'leaves-fn-joby';
    root.setAttribute('data-layout', 'note-tr-v3');
    root.innerHTML =
      '<div class="leaves-fn-joby__head">' +
      '<p class="leaves-fn-joby__note"></p>' +
      '</div>' +
      '<div class="leaves-fn-joby__media"></div>';

    root.querySelector('.leaves-fn-joby__note').textContent = noteText;
    root.querySelector('.leaves-fn-joby__media').appendChild(compare);

    var flex = section.querySelector('.leaves-flex-section') || section;
    Array.prototype.forEach.call(flex.children, function (child) {
      if (child === root) return;
      child.classList.add('leaves-fn-joby__original');
    });

    flex.insertBefore(root, flex.firstChild);
    section.classList.add('leaves-fn-joby-host');
    wakeImages(compare);
    wireSlider(compare);
    placeSection(section);
    return true;
  }

  function boot() {
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      var section =
        document.querySelector('#leaves-home [data-section-id="leaves-373f"]') ||
        document.querySelector('[data-section-id="leaves-373f"]');
      if ((section && build(section)) || tries > 40) {
        window.clearInterval(timer);
        if (section) placeSection(section);
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
